export const Badge = ({
  children,
  variant = 'default',
  className = '',
}) => {
  const variants = {
    default: 'bg-gray-50/80 text-gray-700 border border-gray-200/60',
    success: 'bg-green-50/80 text-green-700 border border-green-200/60',
    warning: 'bg-amber-50/80 text-amber-700 border border-amber-200/60',
    destructive: 'bg-red-50/80 text-red-700 border border-red-200/60',
    secondary: 'bg-gray-50/80 text-gray-600 border border-gray-200/60',
    partner: 'bg-blue-50/80 text-blue-700 border border-blue-200/60',
    internal: 'bg-emerald-50/80 text-emerald-700 border border-emerald-200/60',
    courier: 'bg-orange-50/80 text-orange-700 border border-orange-200/60',
    warehouse: 'bg-indigo-50/80 text-indigo-700 border border-indigo-200/60',
  };

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-medium ${(variants[variant] || variants.default)} ${className}`}
    >
      {children}
    </span>
  );
};

